import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WebsiteData } from '../state-management/model/interfaces/state.model';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class SaveDataService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  public saveToLocalStorage(data: WebsiteData): void {
    if (!isPlatformBrowser(this.platformId)) return;

    if (localStorage) {
      localStorage.setItem('website-data', JSON.stringify(data));
    }
  }

}
